import { accorder } from '../plural.js';
export const nl = {
    langue: {
        selecteur: 'Taal',
    },
    coquille: {
        sautContenu: 'Naar de inhoud',
        deconnexion: 'Afmelden',
        versionInconnue: 'onbekend',
        version: (version, horodatage) => `Versie ${version} — build van ${horodatage}`,
        signature: '— Repère, organisatie & gemoedsrust',
    },
    compte: {
        menu: 'Menu',
        monCompte: 'Mijn account',
        options: 'Opties',
        aide: 'Help',
        mesDossiers: 'Mijn dossiers',
        nouveauDossier: 'Nieuw dossier',
        identiteTitre: 'Uw account',
        formule: 'Formule',
        situation: 'Situatie',
        debut: 'Sinds',
        echeance: 'Tot',
        origine: 'Herkomst',
        origines: {
            stripe: 'Betaald abonnement',
            code_essai: 'Proefcode',
            geste: 'Commercieel gebaar',
        },
        statuts: {
            none: 'Geen abonnement',
            trialing: 'Proef loopt',
            active: 'Actief',
            past_due: 'Betaling in afwachting',
            canceled: 'Opgezegd',
        },
        resiliationProgrammee: 'Uw abonnement stopt aan het eind van de lopende periode.',
        essaiJusquau: (date) => `Gratis proef tot ${date}.`,
        accesCouvert: 'Uw schrijftoegang staat open dankzij de Duo-formule die is afgesloten op een dossier ' +
            'dat u deelt. U kunt altijd zelf een abonnement nemen.',
        accesProfessionnel: 'U schrijft op grond van een professionele toegang die een ouder heeft geopend, niet op grond van een abonnement.',
        factures: 'Mijn facturen en betaling',
        ouvertureFactures: 'Bezig met openen…',
        facturesIndisponibles: 'Geen facturen: uw toegang komt niet voort uit een kaartbetaling.',
        erreurFactures: 'De factuurpagina kon niet worden geopend',
        dossiersTitre: 'Uw dossiers',
        parent: (rang) => `Ouder ${rang}`,
        placeLibre: 'Nog vrij',
        aucunDossier: 'U hebt nog geen dossier.',
        optionsTitre: 'Opties',
        retourPrecedent: 'Terug',
        apparence: 'Weergave',
        apparenceAide: '“Automatisch” volgt de instelling van uw apparaat: het wordt ’s avonds donker zonder dat u eraan denkt.',
        langueTitre: 'Taal',
        langueAide: 'De taal van de applicatie en van haar e-mails.',
        lectureIA: 'Bonnetjes lezen',
        lectureIAAide: 'Wanneer u een foto van een bonnetje aan een uitgave hangt, kan Repère die lezen en ' +
            'bedrag, datum en categorie voorstellen. De foto gaat uitsluitend daarvoor naar ' +
            'Mistral, onze Europese AI-leverancier, en wordt daar niet bewaard. Het is het enige ' +
            'gegeven uit uw dossier dat onze servers verlaat.',
        lectureIAActive: 'Mijn bonnetjes lezen',
        lectureIAInactive: 'Niets versturen, ik typ het zelf',
        notificationsTitre: 'Meldingen',
        silenceAide: 'Tijdens deze uren blijft uw telefoon stil. Er gaat niets verloren: het wordt ' +
            'bewaard en in één keer bezorgd wanneer de stille periode eindigt.',
        silenceActive: '’s Nachts stil houden',
        silenceDesactive: 'Mij op elk moment waarschuwen',
        silenceDebut: 'Vanaf',
        silenceFin: 'Tot',
        silenceNote: (fin) => `Wat tijdens de stille periode binnenkomt, bereikt u om ${fin}, in één bericht. ` +
            'Een dringende waarschuwing komt wel door.',
        silenceNoteInactif: 'U wordt gewaarschuwd zodra er iets gebeurt, op elk uur.',
        emailTitre: 'E-mails',
        emailAide: 'Deze instelling geldt alleen voor uw postvak. De meldingen op uw telefoon ' +
            'veranderen niet.',
        emailImmediat: 'Elke keer een e-mail',
        emailQuotidien: 'Eén samenvatting per dag',
        emailImmediatNote: 'U krijgt een e-mail zodra er iets gebeurt, behalve tijdens uw stille uren.',
        emailQuotidienNote: (heure) => `Eén e-mail per dag, om ${heure}, met het aantal gebeurtenissen. Uw telefoon blijft u ` +
            'meteen waarschuwen. Een dringende waarschuwing gaat hieraan voorbij en wordt ' +
            'onmiddellijk verstuurd.',
        emailHeure: 'Samenvatting verstuurd om',
        conges: 'Schoolvakanties',
        congesAide: 'Waar je agenda de vakantiedata vandaan haalt. De officiële kalender dekt het Franse ' +
            'moederland; een .ics-bestand neemt het over voor de overzeese gebieden, een school in ' +
            'het buitenland of een instelling met eigen data.',
        congesPartage: 'Deze keuze hoort bij het dossier: de andere ouder ziet dezelfde agenda.',
        congesOfficiel: 'Officiële kalender',
        congesOfficielZone: (zone) => `Zone ${zone}, afgeleid van de postcode van de school.`,
        congesOfficielSansZone: 'Geen zone afgeleid: vul de postcode van de school in bij het kind, of upload een bestand.',
        congesFichier: 'Geüpload bestand',
        congesFichierAide: 'Een .ics-bestand uit de agenda van de school. Het wordt bij aankomst gelezen en niet ' +
            'bewaard: alleen de data blijven.',
        congesDeposer: '.ics-bestand kiezen',
        congesDepotEnCours: 'Bestand wordt gelezen…',
        congesDepot: (nom, periodes) => `${nom} · ${periodes} periode${periodes > 1 ? 's' : ''}`,
        congesCouverture: (debut, fin) => `Van ${debut} tot ${fin}.`,
        congesRetirer: 'Dit bestand verwijderen',
        congesErreur: 'Dit bestand kon niet worden gelezen',
        congesAucunDossier: 'Je hebt nog geen dossier om in te stellen.',
        congesMemes: 'Vakanties van de kinderen',
        congesMemesOui: 'Voor iedereen dezelfde',
        congesMemesNon: 'Een instelling per kind',
        congesMemesAide: 'Een middelbare school en een lyceum aan weerszijden van een academiegrens zijn genoeg ' +
            'om broers en zussen te scheiden. Elk kind vertrekt dan van de officiële kalender van ' +
            'ZIJN school, en de agenda omlijnt zijn dagen in zijn kleur.',
        congesEnfant: (prenom) => `Vakanties van ${prenom}`,
    },
    dates: {
        mois: [
            'januari',
            'februari',
            'maart',
            'april',
            'mei',
            'juni',
            'juli',
            'augustus',
            'september',
            'oktober',
            'november',
            'december',
        ],
        jour: 'Dag',
        moisLabel: 'Maand',
        annee: 'Jaar',
    },
    creerDossier: {
        titre: 'Een dossier aanmaken',
        etapeSur4: (etape) => `Stap ${etape} van 4`,
        erreurEtape: 'Deze stap is niet gelukt',
        jalon: { enfants: 'Kinderen', garde: 'Zorgregeling', invitation: 'Uitnodiging', pret: 'Klaar' },
        etatJalon: { termine: 'voltooid', enCours: 'bezig', aVenir: 'nog te doen' },
        etape1: {
            titreCarte: 'Uw kinderen',
            aideFratrie: 'Een dossier bundelt de kinderen die u met dezelfde andere ouder heeft. Om een broer of zus aan een bestaand dossier toe te voegen, opent u dat dossier en gaat u naar “Kinderen”.',
            prenom: 'Voornaam',
            dateNaissance: 'Geboortedatum',
            suffixeRang: (index) => ` van kind ${index + 1}`,
            enfantParDefaut: (index) => `Kind ${index + 1}`,
            retirer: 'Verwijderen',
            retirerSuffixe: (index, prenom) => ` kind ${index + 1}${prenom ? `, ${prenom}` : ''}`,
            ajouter: 'Nog een kind toevoegen',
            continuer: 'Doorgaan',
        },
        etape2: {
            titreCarte: 'De zorgregeling',
            aideModification: 'U kunt dit later wijzigen — elke wijziging vereist de instemming van de andere ouder.',
            schema: 'Regeling',
            nidation: 'Nestmodel (birdnesting)',
            nidationAide: 'Het kind blijft in de gezinswoning en de ouders wisselen elkaar af. De tijdsverdeling blijft die van de gekozen regeling.',
            dateDebut: 'Startdatum',
            heure: 'Tijdstip van overdracht',
            heureAide: 'Vaak na school.',
            quiCommence: 'Wie begint',
            moi: 'Ik',
            autreParent: 'De andere ouder',
            revenir: 'Terug',
            creer: 'Dossier aanmaken',
            creationEnCours: 'Bezig met aanmaken…',
        },
        etape3: {
            titreCarte: 'De andere ouder uitnodigen',
            intro: 'Repère beschermt beide ouders op dezelfde manier: de andere ouder krijgt precies dezelfde rechten als u op dit dossier, en geen van beiden kan de ander iets ontnemen.',
            redaction: 'Het bericht wordt door Repère opgesteld, in een neutrale toon. U hoeft zelf niets te schrijven.',
            email: 'E-mailadres van de andere ouder',
            plusTard: 'Later',
            envoyer: 'Uitnodiging versturen',
            envoiEnCours: 'Bezig met versturen…',
        },
        etape4: {
            titreCarte: 'Uw dossier is klaar',
            messageAvecInvitation: 'De uitnodiging is verstuurd. Het dossier is meteen bruikbaar, zonder op een antwoord te wachten.',
            messageSansInvitation: 'Het dossier is meteen bruikbaar. U kunt de andere ouder uitnodigen wanneer u wilt.',
            ouvrir: 'Dossier openen',
        },
        residence: {
            pays: 'Woonland van het kind',
            ville: 'Woonplaats van het kind',
            zone: (zone) => `Schoolvakantiezone ${zone}.`,
            zoneInconnue: 'Zone niet herkend — de exacte spelling van de gemeente helpt om deze te vinden.',
        },
    },
    entree: {
        presentation: {
            accrocheCourte: 'De zorgkalender, de berichten en de documenten van uw kinderen, allemaal op één plek.',
            accrocheLongue: 'Repère is het hulpmiddel voor gescheiden ouders: de zorgkalender, de berichten en de documenten van uw kinderen, allemaal op één plek.',
            publics: 'Het is er voor beide ouders, ongeacht de zorgregeling en ongeacht de staat van uw relatie. Een advocaat, bemiddelaar of maatschappelijk werker kan als lezer worden uitgenodigd, als een van u dat besluit.',
            garanties: 'Alles wordt door onze servers van een tijdstempel voorzien, en niets kan daarna nog worden gewijzigd of verwijderd — niet door u, niet door de andere ouder, niet door ons team. Ieder heeft precies dezelfde rechten en ziet precies hetzelfde.',
        },
        modesAcces: {
            titre: 'Heeft u een uitnodiging ontvangen?',
            autreParentTitre: 'U bent de andere ouder',
            autreParentTexte: 'Toetreden tot het dossier is gratis: registratie en de kalender vereisen geen abonnement. Ieder kan vervolgens zijn eigen abonnement nemen als hij dat wenst — € 9,90 per maand — en niemand kan de toegang van de ander afsluiten.',
            proTitre: 'U bent advocaat, bemiddelaar of maatschappelijk werker',
            proTexte: 'Uw account is gratis, zonder beperking van het aantal dossiers. U krijgt leestoegang tot wat een ouder met u deelt, voor de duur die hij bepaalt. De andere ouder wordt op de hoogte gebracht van uw komst: niemand betreedt een dossier zonder dat iemand het weet.',
        },
        fournisseurs: {
            indisponible: 'Binnenkort beschikbaar',
            separateurOu: 'of',
            intro: 'Met een account die u al heeft — geen nieuw wachtwoord om te onthouden.',
            redirection: (nom) => `Doorverwijzen naar ${nom}…`,
            verbeAvec: (verbe, nom) => `${verbe} met ${nom}`,
            indisponibleDetail: 'Binnenkort beschikbaar. Het e-mailadres en wachtwoord geven toegang tot het hele product: geen enkele functie zal ooit afhankelijk zijn van een account van derden.',
        },
        feuille: {
            fermer: 'Sluiten',
        },
        connexion: {
            titre: 'Inloggen',
            verbe: 'Inloggen',
            pasDeCompte: 'Nog geen account?',
            sInscrire: 'Registreren',
            email: 'E-mailadres',
            motDePasse: 'Wachtwoord',
            motDePasseOublie: 'Wachtwoord vergeten?',
            connexionEnCours: 'Bezig met inloggen…',
            erreurTitre: 'Inloggen niet gelukt',
            echecRefus: 'Het inloggen werd onderbroken. U kunt het opnieuw proberen, of uw e-mailadres en wachtwoord invoeren.',
            echecExpire: 'Het inloggen duurde te lang. Probeer het opnieuw.',
            echecGenerique: 'Het inloggen via deze provider is niet gelukt. U kunt in plaats daarvan uw e-mailadres en wachtwoord invoeren.',
        },
        inscription: {
            titre: 'Account aanmaken',
            verbe: 'Registreren',
            motDePasseTropCourt: 'Het wachtwoord moet minstens 12 tekens lang zijn.',
            verifiezBoite: 'Controleer uw postvak',
            siAdresseUtilisable: 'Als dit adres kan worden gebruikt, is er zojuist een bericht naartoe gestuurd. Open de link erin om uw adres te bevestigen.',
            dejaConnexionPossible: 'U kunt al inloggen: de bevestiging kan wachten.',
            dejaCompte: 'Heeft u al een account?',
            seConnecter: 'Inloggen',
            prenom: 'Voornaam',
            prenomAide: 'Wordt getoond aan de andere ouder.',
            email: 'E-mailadres',
            motDePasse: 'Wachtwoord',
            motDePasseAide: 'Minstens 12 tekens. Een zin die u onthoudt maakt een goed wachtwoord.',
            erreurTitre: 'Account aanmaken niet gelukt',
            creationEnCours: 'Bezig met aanmaken…',
            creerMonCompte: 'Mijn account aanmaken',
            echecGenerique: 'Er ging iets mis. Probeer het zo meteen opnieuw.',
        },
    },
    dossier: {
        categories: {
            aujourdhui: 'Vandaag',
            calendrier: 'Kalender',
            messages: 'Berichten',
            depenses: 'Uitgaven',
            journal: 'Journaal',
            enfants: 'Kinderen',
        },
        navigation: {
            ariaCategories: 'Categorieën van het dossier',
            reserveParent: 'Voorbehouden aan de abonnementen Solo en Duo. Wat al is opgeslagen blijft leesbaar.',
            reserveParentSuffixe: ', voorbehouden aan Solo en Duo',
            nouveaute: (n) => accorder('nl', n, { one: '1 nieuwigheid', other: `${n} nieuwigheden` }),
        },
        calendrier: {
            moisPrecedent: 'Vorige maand',
            moisSuivant: 'Volgende maand',
            erreurChargement: 'De kalender kon niet worden geladen',
            titre: (moisEtAnnee) => `Zorgkalender — ${moisEtAnnee}`,
            chezVous: 'Bij u',
            chezAutre: (nom) => `Bij ${nom}`,
            nonDefini: 'niet vastgelegd',
            libelleEchange: 'dagwisseling',
            libelleDerogation: 'overeengekomen uitzondering',
            titreEchange: 'Overeengekomen dagwisseling',
            titreDerogationConvenue: 'Overeengekomen uitzondering',
            avecMotif: (base, motif) => `${base} — ${motif}`,
            suffixeDerogation: (libelle) => `, ${libelle}`,
            suffixeMotif: (motif) => `, reden: ${motif}`,
            marqueEchange: 'Gewisseld',
            legendeEchange: 'Dag in onderling overleg gewisseld',
            suffixeConge: ' — schoolvakantie',
            suffixeCongeEnfants: (prenoms) => ` — schoolvakantie: ${prenoms}`,
            legendeConge: (zone) => `Schoolvakantie · zone ${zone}`,
            legendeCongeFichier: 'Schoolvakantie · geüpload bestand',
            legendeCongeEnfant: (prenom, source) => `${prenom} — ${source}`,
            legendeCongesAbsents: 'Schoolvakantie: niets te tonen. Vul de postcode van de school in bij het kind, of ' +
                'upload een vakantiebestand via Mijn account › Opties.',
        },
        journal: {
            ariaFiltrer: 'Journaal filteren',
            filtreTout: 'Alle',
            filtrePartagees: 'Gedeeld',
            filtrePrivees: 'Privé',
            entreeSuffixe: (n) => accorder('nl', n, { one: ', 1 vermelding', other: `, ${n} vermeldingen` }),
            erreurChargement: 'Het journaal kon niet worden geladen',
            modeSoloTexte: 'U bent voorlopig alleen op dit dossier, en het journaal werkt normaal. Als de andere ouder later toetreedt, ziet hij de vermeldingen die u als gedeeld hebt gemarkeerd, met hun oorspronkelijke datum.',
            videTout: 'Nog geen vermeldingen.',
            videPartagees: 'Geen gedeelde vermeldingen.',
            videPrivees: 'Geen privévermeldingen.',
            auteurVous: 'U',
            auteurAutreParent: 'De andere ouder',
            marquePrivee: 'Privé',
            marquePartagee: 'Gedeeld',
            invisibleSuffixePrivee: 'Privévermelding, alleen zichtbaar voor u, onveranderlijk.',
            invisibleSuffixePartagee: 'Met de andere ouder gedeelde vermelding, onveranderlijk.',
            mentionImmuable: 'Elke vermelding krijgt een tijdstempel van onze servers en kan daarna niet meer worden gewijzigd of verwijderd — niet door u, niet door de andere ouder, niet door ons team. Noteer feiten: wat er gebeurde, wanneer.',
            mentionImmuableBouton: 'Onveranderlijkheid van het logboek',
            labelFait: 'Het te noteren feit',
            placeholderFait: 'Het te noteren feit — "Overdracht om 18:05 uur gebeurd"',
            ariaQuiPeutVoir: 'Wie kan deze vermelding zien?',
            intituleVisiblePar: 'Zichtbaar voor',
            visibiliteAutre: 'De andere ouder',
            visibiliteAutreAide: 'Ze verschijnt identiek in het journaal van beide ouders.',
            visibiliteMoi: 'Alleen u',
            visibiliteMoiAide: 'De andere ouder wordt niet ingelicht. Ze verschijnt alleen in uw eigen export.',
            aideChoixDefaut: 'Kies wie deze vermelding zal zien: niets staat vooraf aangevinkt.',
            enregistrementEnCours: 'Bezig met opslaan…',
            consigner: 'Noteren',
            erreurEnregistrement: 'De vermelding kon niet worden opgeslagen',
            reformuler: 'Herformuleer deze tekst voor mij',
            reformulationEnCours: 'Bezig met herformuleren…',
            reformulationTitre: 'Een andere manier om het te zeggen',
            reformulationAide: 'Er wordt niets bewaard: niet uw concept, en niet dit voorstel — niemand komt ' +
                'te weten dat u erom hebt gevraagd.',
            reformulationUtiliser: 'Deze versie gebruiken',
            reformulationGarder: 'Mijn tekst houden',
            reformulationDejaNeutre: 'Uw tekst is al feitelijk: er valt niets te verzachten.',
            reformulationIndisponible: 'Herformuleren is nu niet beschikbaar. U kunt uw tekst ongewijzigd noteren.',
            reformulationBudget: 'U hebt uw herformuleringen van vandaag gebruikt. Morgen zijn er weer.',
            reformulationTropLong: 'Deze tekst is te lang om te herformuleren.',
        },
        depenses: {
            statutAttente: 'Wacht op antwoord',
            statutAcceptee: 'Geaccepteerd',
            statutContestee: 'Betwist',
            statutRemboursee: 'Terugbetaald',
            categories: ['gezondheid', 'school', 'kantine', 'activiteiten', 'kleding', 'vervoer'],
            comptesAJour: 'De rekeningen zijn bijgewerkt.',
            soldePhrase: (debiteur, jeSuisDebiteur, montant, crediteur) => `${debiteur} ${jeSuisDebiteur ? 'bent' : 'is'} ${crediteur} ${montant} verschuldigd.`,
            detailLigneALigne: 'Het detail, regel voor regel',
            ligneDetail: (date, categorie, montant, payeur, montantAutre) => `${date} — ${categorie}: ${montant} voorgeschoten door ${payeur}, waarvan ${montantAutre} ten laste van de ander.`,
            soldeNonStocke: 'Dit saldo wordt nergens opgeslagen: het wordt bij elke weergave herberekend op basis van deze regels. U kunt de som zelf overdoen.',
            sansRegleTitre: 'Sommige uitgaven wachten op een verdeelregel',
            sansRegleTexte: (n) => accorder('nl', n, {
                one: '1 uitgave dateert van vóór elke regel en telt niet mee.',
                other: `${n} uitgaven dateren van vóór elke regel en tellen niet mee.`,
            }),
            erreurChargement: 'De uitgaven konden niet worden geladen',
            declarerUneDepense: 'Een uitgave opgeven',
            justificatifAnalyse: 'Geanalyseerd, versleuteld en toegevoegd aan de documenten van het dossier.',
            lectureTitre: 'Het bonnetje voor u lezen?',
            lectureQuestion: 'Repère kan de foto van uw bonnetje lezen en bedrag, datum en categorie ' +
                'voorstellen. U controleert, corrigeert en bevestigt.',
            lectureDetail: 'De foto gaat uitsluitend daarvoor naar Mistral, onze Europese AI-leverancier. Hij ' +
                'wordt daar niet bewaard, en wij bewaren evenmin iets. Het is het enige gegeven uit ' +
                'uw dossier dat onze servers verlaat — u kunt deze toestemming altijd intrekken bij ' +
                '„Opties”.',
            lectureAccepter: 'Ja, lees mijn bonnetjes',
            lectureRefuser: 'Nee, ik typ het zelf',
            lectureEnCours: 'Bezig met lezen…',
            lectureProposee: 'Bedrag, datum, categorie en opmerking voorgesteld op basis van het bonnetje. Controleer ze.',
            commentaire: 'Opmerking',
            commentairePlaceholder: 'Apotheek in het centrum — antibiotica en verband',
            commentaireAide: 'Optioneel. Wat het bonnetje zegt: de winkel, wat er is gekocht. Het uitlezen van het ' +
                'bonnetje kan het voorstellen; u leest het na.',
            lectureRien: 'Op deze foto was niets te lezen. Voer de uitgave handmatig in.',
            lectureIndisponible: 'Lezen is nu niet beschikbaar. Voer de uitgave handmatig in.',
            lectureBudget: 'U hebt uw lezingen van vandaag gebruikt. Morgen zijn er weer.',
            lectureQuota: 'Dit dossier heeft zijn vijf lezingen van vandaag gebruikt. Morgen zijn er weer.',
            retirer: 'Verwijderen',
            photographierLeTicket: 'Bonnetje fotograferen',
            choisirUnFichier: 'Een bestand kiezen',
            envoiEnCours: 'Bezig met verzenden…',
            justificatifAide: 'Optioneel, maar het geeft de doorslag bij betwisting van de uitgave. PDF of foto.',
            erreurJustificatif: 'Het bewijsstuk kon niet worden toegevoegd',
            montant: 'Bedrag',
            montantInvalide: 'Ongeldig bedrag.',
            dateDeLaDepense: 'Datum van de uitgave',
            ariaCategorie: 'Categorie van de uitgave',
            erreurDeclaration: 'De uitgave kon niet worden opgeslagen',
            enregistrementEnCours: 'Bezig met opslaan…',
            declarerLaDepense: 'Uitgave opgeven',
            aideAvecCategorie: 'De gekozen datum bepaalt de toegepaste verdeelregel.',
            aideSansCategorie: 'Kies een categorie: niets staat vooraf ingesteld.',
            unParent: 'Een ouder',
            vous: 'U',
            justificatifJoint: 'Bewijsstuk toegevoegd',
            avancePar: (date, payeur) => `${date} · voorgeschoten door ${payeur}`,
            accepter: 'Accepteren',
            motifSiConteste: 'Reden, als u het betwist',
            motifAide: 'Een onenigheid zonder reden leidt nergens toe: zeg wat het probleem is.',
            contester: 'Betwisten',
            videListe: 'Nog geen uitgaven.',
            ongletDetail: 'Details',
            ongletPartagees: 'Gedeelde uitgaven',
        },
        messagerie: {
            ariaFils: 'Gespreksonderwerpen',
            filTous: 'Alle',
            filSansFil: 'Geen onderwerp',
            filSante: 'Gezondheid',
            filEcole: 'School',
            filVacances: 'Vakanties',
            filUrgences: 'Noodgevallen',
            messageSuffixe: (n) => accorder('nl', n, { one: ', 1 bericht', other: `, ${n} berichten` }),
            erreurChargement: 'De berichten konden niet worden geladen',
            ouvrirLaPieceJointe: 'De bijlage openen',
            erreurOuverturePiece: 'De bijlage kon niet worden geopend',
            pieceJointeScellee: 'Verzegeld met het bericht: vervangen zou de vingerafdruk breken.',
            redactionPieceScellee: (nomFichier) => `${nomFichier} — geanalyseerd, versleuteld, en de vingerafdruk verzegeld met het bericht: later vervangen zou de keten breken.`,
            videAucun: 'Nog geen berichten.',
            videAucunDansCeFil: 'Geen berichten in dit onderwerp.',
            nouveauxMessages: (n) => accorder('nl', n, { one: '1 nieuw bericht', other: `${n} nieuwe berichten` }),
            vosEnvoisDifferes: 'Uw geplande verzendingen',
            envoisDifferesAide: 'Alleen zichtbaar voor u zolang ze niet zijn verzonden. U kunt ze nog annuleren.',
            envoiPrevu: (corps, date, heureTexte) => `"${corps}" — verzending gepland op ${date} om ${heureTexte}`,
            annulerCetEnvoi: 'Deze verzending annuleren',
            retirer: 'Verwijderen',
            mentionImmuable: 'Hier uitgewisselde berichten kunnen niet worden gewijzigd of verwijderd — niet door u, niet door de andere ouder, niet door ons team. Elk krijgt een tijdstempel van onze servers.',
            mentionImmuableBouton: 'Onveranderlijkheid van berichten',
            reformuler: 'Herformuleer dit bericht voor mij',
            reformulationEnCours: 'Bezig met herformuleren…',
            reformulationTitre: 'Een andere manier om het te zeggen',
            reformulationAide: 'Er is niets verzonden en er wordt niets bewaard: niet uw concept, en niet dit ' +
                'voorstel. De andere ouder komt niet te weten dat u erom hebt gevraagd.',
            reformulationUtiliser: 'Deze versie gebruiken',
            reformulationGarder: 'Mijn tekst houden',
            reformulationDejaNeutre: 'Uw bericht is al feitelijk: er valt niets te verzachten.',
            reformulationIndisponible: 'Herformuleren is nu niet beschikbaar. Uw bericht gaat ongewijzigd weg.',
            reformulationBudget: 'U hebt uw herformuleringen van vandaag gebruikt. Morgen zijn er weer.',
            reformulationTropLong: 'Dit bericht is te lang om te herformuleren.',
            votreMessage: 'Uw bericht',
            placeholderEcrire: 'Een bericht schrijven…',
            joindreUnDocument: 'Een document toevoegen',
            envoyerPlusTard: 'Later verzenden',
            envoiEnCours: 'Bezig met verzenden…',
            programmerLEnvoi: 'De verzending plannen',
            envoyer: 'Verzenden',
            dateEtHeureEnvoi: 'Datum en tijdstip van verzending',
            aideHorodatage: 'De geldende tijdstempel is die van de daadwerkelijke verzending.',
            erreurEnvoi: 'Het bericht kon niet worden verzonden',
            inactiveTexte: 'Berichten worden geactiveerd zodra de andere ouder tot het dossier is toegetreden: zonder gesprekspartner heeft het geen zin.',
            auteurVous: 'U',
            auteurAutreParent: 'De andere ouder',
            messageInvisible: (date, heureTexte, numero) => `${date} om ${heureTexte}. Bericht nummer ${numero}, onveranderlijk.`,
        },
        suppression: {
            ouvrir: 'Dit dossier verwijderen',
            titre: 'Dit dossier verwijderen',
            texte: 'Verwijderen beslist u samen: de andere ouder ontvangt een bericht en moet ' +
                'bevestigen. Na bevestiging blijft het dossier dertig dagen leesbaar zonder ' +
                'gewijzigd te kunnen worden, daarna wordt het definitief vernietigd. In die periode ' +
                'kan ieder van beiden alles annuleren.',
            texteSolo: 'U bent alleen in dit dossier: het bevestigingsbericht gaat naar u. Na bevestiging ' +
                'blijft het dossier dertig dagen leesbaar zonder gewijzigd te kunnen worden, daarna ' +
                'wordt het definitief vernietigd. U kunt tot de laatste dag alles annuleren.',
            demander: 'Verwijdering aanvragen',
            envoiEnCours: 'Bezig met verzenden…',
            erreur: 'De aanvraag kon niet worden verzonden',
            renoncer: 'Niet verwijderen',
            attenteAutre: 'Er is verwijdering van dit dossier aangevraagd. De andere ouder heeft een bericht ' +
                'gekregen: het gaat pas in als die bevestigt.',
            attenteVous: 'Er is verwijdering van dit dossier aangevraagd. U hebt een bericht gekregen: open ' +
                'het om te bevestigen of te weigeren.',
            attenteEcheance: (date) => `Zonder antwoord vervalt deze aanvraag vanzelf op ${date}.`,
            archiveTitre: 'Gearchiveerd dossier',
            archiveTexte: (date) => `Dit dossier wordt op ${date} definitief vernietigd.`,
            archiveLecture: 'Tot dan blijft het leesbaar — u kunt het teruglezen en een export aanvragen — maar ' +
                'niemand kan er nog in schrijven.',
            annuler: 'Verwijdering annuleren',
            annulationEnCours: 'Bezig met annuleren…',
        },
        ecran: {
            modeSolo: `U gebruikt dit dossier alleen`,
            modePartage: `Gedeeld dossier · identieke rechten`,
            modePartageAvec: (prenom) => `Gedeeld met ${prenom} · identieke rechten`,
            quiALEnfant: `Wie heeft het kind?`,
            quiReponseVous: `Het kind is bij u`,
            quiReponseAutre: (prenom) => `Het kind is bij ${prenom}`,
            quiAucunSchema: `Geen zorgregeling dekt deze datum`,
            quiDerogation: `Bij afgesproken uitzondering.`,
            quiRecherche: `Bezig met zoeken…`,
            quiErreur: `Het antwoord kon niet worden opgehaald`,
            quiDateAujourdhui: (date) => `Vandaag, ${date}`,
            quiQuelleDate: `Welke datum?`,
            quiAutreJour: `Een andere dag bekijken`,
            quiRevenirAujourdhui: `Terug naar vandaag`,
            demandesAccord: `Verzoeken om instemming`,
            ongletNouveautes: `Nieuw`,
            ongletDossier: `Het dossier`,
            modeSoloTexte: `De kalender, het journaal en de documenten werken normaal. Alles wat u vanaf nu vastlegt krijgt een tijdstempel.`,
            invitationEnvoyeeTexte: `Er is een uitnodiging verstuurd. Deze blijft 30 dagen geldig.`,
            renvoyerOuCorriger: `Adres opnieuw versturen of corrigeren`,
            nouvelleAdresseRemplace: `Het nieuwe adres vervangt het vorige: de al verzonden link wordt ongeldig.`,
            peutInviterQuandVeut: `U kunt de andere ouder uitnodigen wanneer u wilt.`,
            erreurInvitation: `De uitnodiging kon niet worden verzonden`,
            emailAutreParent: `E-mailadres van de andere ouder`,
            aideInvitation: `Het bericht wordt door Repère opgesteld, in een neutrale toon.`,
            envoiEnCours: `Bezig met verzenden…`,
            envoyerInvitation: `Uitnodiging verzenden`,
            calendrierDeGarde: `De zorgkalender`,
            demanderEchange: `Een dagwisseling aanvragen`,
            historiqueSchema: `Geschiedenis van de zorgregeling`,
            depensesPartagees: `Gedeelde uitgaven`,
            ficheDe: (prenom) => `Profiel van ${prenom}`,
        },
    },
    schemasDeGarde: {
        schemas: {
            alternating_week: {
                libelle: 'Wisselweek (7/7)',
                detail: 'Eén week bij de één, één week bij de ander. De meest voorkomende regeling.',
            },
            two_two_five_five: {
                libelle: '2-2-5-5',
                detail: 'Twee vaste dagen bij elk per week, dan vijf dagen inclusief het weekend.',
            },
            two_two_three: {
                libelle: '2-2-3',
                detail: 'Twee nachten, twee nachten, drie nachten: bedoeld voor jonge kinderen.',
            },
            three_four_four_three: {
                libelle: '3-4-4-3',
                detail: 'Wisseling midden in de week, over een cyclus van twee weken.',
            },
            fortnight: {
                libelle: 'Wisselende veertien dagen (14/14)',
                detail: 'Twee weken bij elk: tieners, of geografische afstand.',
            },
            nine_five: {
                libelle: '9/5-wisseling',
                detail: 'Negen nachten bij de één, vijf bij de ander, over een cyclus van twee weken.',
            },
            ten_four: {
                libelle: '10/4-wisseling',
                detail: 'Tien nachten bij de één, vier bij de ander, over een cyclus van twee weken.',
            },
            alternate_weekends: {
                libelle: 'Om het weekend (1e, 3e, 5e)',
                detail: 'Klassiek omgangs- en overnachtingsrecht: om het weekend, vrijdag tot zondag.',
            },
            extended_weekends: {
                libelle: 'Uitgebreide wisselweekenden',
                detail: 'Uitgebreid omgangsrecht: om het weekend, van vrijdagavond tot maandagochtend.',
            },
            visits_only: {
                libelle: 'Bezoek zonder overnachting',
                detail: 'Beperkt omgangsrecht: alleen overdag, geen overnachting. Elk bezoek wordt in de kalender gezet.',
            },
            holidays_only: {
                libelle: 'Alleen schoolvakanties',
                detail: 'Omgangsrecht op grote afstand: geen vaste weekenden, het grootste deel van de vakanties.',
            },
            third_party: {
                libelle: 'Verblijf bij een derde',
                detail: 'Het kind verblijft bij een derde; de tijd van elke ouder wordt afzonderlijk vastgelegd.',
            },
            custom: {
                libelle: 'Op maat',
                detail: 'Geen automatische generatie: de kalender wordt periode voor periode opgebouwd.',
            },
        },
        familles: {
            alternance: 'Co-ouderschap',
            alternance_inegale: 'Ongelijk co-ouderschap',
            residence_principale: 'Hoofdverblijf bij één ouder',
            autre: 'Anders',
        },
    },
    apercu: {
        titre: 'Voorbeeld van de wisselregeling',
        pasDeCycle: (libelle) => `"${libelle}" heeft geen cyclus om af te spelen: de tijd van elke ouder wordt periode voor periode vastgelegd, in de kalender van het dossier. Er valt hier dus niets in voorbeeld te tonen.`,
        choisirDate: 'Kies een startdatum: het voorbeeld toont dan de eerste drie maanden, dag voor dag.',
        aPartirDu: (date) => `Vanaf ${date}:`,
        joursChezVous: (n) => accorder('nl', n, { one: '1 dag bij u', other: `${n} dagen bij u` }),
        etJoursChezAutre: (n) => `en ${n} bij de andere ouder, over de getoonde drie maanden.`,
        chezVousInvisible: ', bij u',
        chezAutreInvisible: ', bij de andere ouder',
        legendeChezVous: 'Bij u',
        legendeChezAutre: 'Bij de andere ouder',
        legendePassage: 'Overdracht',
    },
    site: {
        nav: {
            accueil: 'Home',
            tarifs: 'Tarieven',
            connexion: 'Inloggen',
            inscription: 'Registreren',
        },
        footer: {
            accroche: 'Organisatie en gemoedsrust voor gescheiden ouders. Gehost in Frankrijk, geen trackers, geen cookies van derden.',
            produit: 'Product',
            tarifsLien: 'Tarieven',
            applicationsLien: 'Mobiele apps',
            legal: 'Juridisch',
            mentionsLegales: 'Wettelijke vermeldingen',
            confidentialite: 'Privacybeleid',
            pied: (annee) => `Repère-kids — ${annee}. Gehost in Frankrijk.`,
            version: (version, horodatage) => `Versie ${version} — build van ${horodatage}`,
        },
        accueil: {
            titre: 'Coördinatie voor gescheiden ouders',
            description: 'Repère: zorgkalender, gedeelde uitgaven, berichten met tijdstempel en een onveranderlijke geschiedenis voor gescheiden ouders.',
            badgeConfiance: 'Gehost in Frankrijk · Geen tracker',
            h1: 'Coördinatie, zonder dat elke uitwisseling een onderhandeling wordt.',
            accroche: 'Een zorgkalender, gedeelde uitgaven, documenten, berichten — en een spoor met tijdstempel dat geen van beide ouders kan herschrijven.',
            etrePrevenu: 'Bericht ontvangen bij lancering',
            pointChiffre: 'Versleuteld per dossier',
            pointServeurs: 'Servers in Frankrijk',
            pointHistorique: 'Onveranderlijke geschiedenis',
            question: 'Wie heeft de kinderen op woensdag?',
            reponseForte: 'Woensdag 16 september — bij u',
            reponseSuite: 'Volgende overdracht: vrijdag 18, 16:30 uur',
            moisCarte: 'September 2026',
            legendeChezVous: 'Bij u',
            legendeChezAutre: 'Bij de andere ouder',
            captureAlt: 'Schermafbeelding van Repère-kids: de zorgkalender van een gedeeld dossier, augustus 2026.',
            captureLegende: 'De app, kalenderweergave. Fictieve gegevens.',
            surTitreChange: 'Wat Repère verandert',
            titreChange: 'Drie vragen die niet meer besproken hoeven te worden',
            introChange: 'De kalender, de afspraken en de geschiedenis — elk eens en voor altijd geregeld door het product, niet door u.',
            carte1Titre: 'Een kalender die meteen antwoord geeft',
            carte1Texte: 'Wie heeft het kind op woensdag? Het antwoord staat op het scherm, voor vandaag zoals voor elke andere datum.',
            carte2Titre: 'Gedateerde afspraken',
            carte2Texte: 'Een ruil van dagen wordt voorgesteld, aanvaard of geweigerd. Elke stap wordt vastgelegd, niemand hoeft te onthouden wie wat heeft gezegd.',
            carte3Titre: 'Een geschiedenis die van niemand is',
            carte3Texte: 'Noch u, noch de andere ouder, noch onze klantenservice kan wijzigen of verwijderen wat is gedeeld.',
            surTitreParti: 'Uitgangspunt',
            titreParti: 'Ontworpen om nooit een wapen te worden',
            texteParti: 'Repère legt feiten vast; het interpreteert of ensceneert ze niet. Beide ouders hebben precies dezelfde rechten — geen van beiden kan de ander uitsluiten of iets uit de gedeelde geschiedenis verwijderen.',
            absencesIntitule: 'Wat u hier niet zult vinden',
            absence1: 'Leesbevestiging',
            absence2: 'Status "online", "voor het laatst gezien", "laatste verbinding"',
            absence3: 'Teller van te laat komen, gedragsscore',
            absence4: '"Eigenaar"-account van het dossier',
            surTitreAcces: 'Toegangsmogelijkheden',
            titreAcces: 'Heeft u een uitnodiging ontvangen?',
            introAcces: 'De vraag komt op vóór het aanmaken van een account, dus het antwoord komt vóór het formulier.',
            acces1Titre: 'U bent de andere ouder',
            acces1Texte: 'Deelnemen aan het dossier is gratis: registratie en de kalender vereisen geen abonnement. Elke ouder kan daarna zelf een abonnement nemen als hij dat wenst — 9,90 € per maand — en niemand kan de toegang van de ander afsluiten.',
            acces1Badge: 'Gratis',
            acces2Titre: 'U bent advocaat, bemiddelaar of maatschappelijk werker',
            acces2Texte: 'Uw account is gratis, zonder limiet op het aantal dossiers. U krijgt leestoegang tot wat een ouder voor u opent, voor de duur die hij bepaalt. De andere ouder wordt op de hoogte gebracht van uw komst: niemand betreedt een dossier buiten medeweten van iemand.',
            acces2Badge: 'Gratis, onbeperkt',
            acces3Titre: 'U verkent de dienst zonder iets ontvangen te hebben',
            acces3Texte: 'Schrijf u in op de wachtlijst om bij de opening bericht te ontvangen. U maakt pas een dossier aan wanneer u besluit de andere ouder uit te nodigen.',
            acces3Badge: 'Zonder account',
            surTitreTarifs: 'Tarieven',
            titreTarifs: 'Eén abonnement per ouder. Niets anders.',
            introTarifs: 'Geen "premium"-versie die rechten over de ander vrijgeeft: beide ouders zien hetzelfde, ongeacht hun abonnement.',
            basculeLegende: 'Facturatiefrequentie',
            basculeMensuel: 'Maandelijks',
            basculeAnnuel: 'Jaarlijks',
            tarifRejoindreTitre: 'Link',
            tarifRejoindrePrix: '0 €',
            tarifRejoindreTexte: 'Voor de ouder die wordt uitgenodigd om deel te nemen aan een bestaand dossier.',
            tarifRejoindreAvantage1: 'Gedeelde zorgkalender',
            tarifRejoindreAvantage2: 'Volledige leestoegang tot de geschiedenis',
            tarifRejoindreAvantage3: 'Geen einddatum',
            tarifParentTitre: 'Solo',
            tarifParentEtiquette: 'Meest gekozen',
            tarifParentPrixMensuel: '9,90 € / maand, per ouder',
            tarifParentPrixMensuelDuo: '14,90 € / maand, voor beide ouders',
            tarifParentPrixAnnuelSeul: '99 € / jaar, per ouder',
            tarifParentPrixAnnuelDuo: '149 € / jaar, voor beide ouders',
            tarifParentPrixAnnuel: 'Twee maanden gratis ten opzichte van maandelijks.',
            tarifParentEssaiGratuit: '7 dagen gratis proberen',
            tarifParentBoutonNotification: 'Mijn Early bird-toegang reserveren',
            tarifParentSwitchDuo: 'De andere ouder toevoegen',
            tarifParentEarlybirdEtiquette: 'Early bird',
            tarifParentEarlybirdTexte: '79 € voor het eerste jaar voor wie zich inschrijft op de wachtlijst, daarna jaartarief.',
            tarifParentEarlybirdTexteDuo: '129 € voor het eerste jaar voor wie zich inschrijft op de wachtlijst, daarna jaartarief.',
            tarifParentEngagement: 'Geen maandelijkse verbintenis. Met één klik op te zeggen vanuit uw account.',
            tarifParentOptionDeuxEtiquette: 'Duo',
            tarifParentOptionDeuxTexte: '+5 € per maand, in totaal 14,90 €, om ook het abonnement van de andere ouder te dekken.',
            tarifParentOptionDeuxTexteAnnuel: '+50 € per jaar, in totaal 149 €, om ook het abonnement van de andere ouder te dekken.',
            tarifParentAvantage1: 'Alles wat Link biedt',
            tarifParentAvantage2: 'Berichten, gedeelde uitgaven, versleutelde documenten',
            tarifParentAvantage3: 'Ruilvoorstellen en logboek',
            tarifParentAvantage4: 'Export van het dossier met tijdstempel',
            tarifParentAvantage5: 'Uitnodigen van een professional met leestoegang',
            tarifProTitre: 'Pro',
            tarifProPrix: '0 €',
            tarifProTexte: 'Advocaat, familiebemiddelaar, maatschappelijk werker.',
            tarifProAvantage1: 'Onbeperkt aantal dossiers',
            tarifProAvantage2: 'Leestoegang, op uitnodiging van een ouder',
            tarifProAvantage3: 'Geverifieerde export van de geschiedenis',
            mentionTarifs: 'Prijzen inclusief btw. De dienst is nog niet geopend: de precieze voorwaarden — proefperiode, opzegvoorwaarden — worden hier gepubliceerd bij de opening.',
            surTitreMobile: 'Op de telefoon',
            titreMobile: 'De kalender op zak, de geschiedenis op dezelfde plek',
            texteMobile: 'De iOS- en Android-apps geven toegang tot hetzelfde dossier als het web: dezelfde rechten, dezelfde gegevens, dezelfde geschiedenis. Een melding waarschuwt u voor een ruilvoorstel of een dringende melding — nooit voor het feit dat de andere ouder online is.',
            appStore: 'App Store',
            googlePlay: 'Google Play',
            mobileNote: 'De links naar App Store en Google Play worden geactiveerd bij de opening van de dienst.',
            mobileCalendrierAlt: 'Voorbeeld van het kalenderscherm van de mobiele app.',
            mobileDossiersAlt: 'Voorbeeld van het beginscherm van de mobiele app: de lijst met dossiers.',
            mobileLegende: 'Voorbeelden van de mobiele app. Fictieve gegevens.',
        },
        waitlist: {
            titre: 'Bericht ontvangen bij lancering',
            texte: 'Laat uw adres achter: u ontvangt een bericht bij de opening, en verder niets. Geen nieuwsbrief, geen herinnering.',
            labelEmail: 'E-mailadres',
            bouton: 'Inschrijven',
            aide: 'Wordt alleen gebruikt om u te verwittigen bij de lancering. Op elk moment verwijderbaar.',
            erreurEmailInvalide: 'Voer een geldig e-mailadres in.',
            envoiEnCours: 'Bezig met verzenden…',
            succes: 'Genoteerd. U ontvangt een bericht bij de lancering.',
            echec: 'De inschrijving is niet gelukt. Probeer het straks opnieuw.',
        },
        confidentialite: {
            titre: 'Privacybeleid',
            description: 'Hoe Repère persoonsgegevens verwerkt: hosting in Frankrijk, versleuteling, geen trackers.',
            avisProvisoire: 'Voorlopig document, in afwachting van juridische validatie. Het beschrijft getrouw de technische werking van de dienst, maar de juridische redactie moet vóór de opening worden herzien door een raadsman (zie de routekaart van het project).',
            miseAJour: (date) => `Laatste update: ${date}.`,
            siteTitre: 'Deze site',
            siteTexte1: 'De site plaatst geen enkele cookie en roept geen enkele dienst van derden aan.',
            siteTexte2: 'Als u zich inschrijft op de wachtlijst, wordt alleen uw e-mailadres bewaard, samen met de pagina waarvandaan de inschrijving komt. Het wordt uitsluitend gebruikt om u te verwittigen bij de lancering, en u kunt op elk moment om verwijdering vragen.',
            serviceTitre: 'De dienst',
            serviceHebergementTitre: 'Hosting in Frankrijk',
            serviceHebergementTexte: ', back-ups inbegrepen. Geen overdracht buiten de Europese Unie.',
            serviceChiffrementTitre: 'Versleuteling',
            serviceChiffrementTexte: ': uitwisselingen worden versleuteld tijdens transport; gevoelige inhoud en documenten worden versleuteld opgeslagen, met een eigen sleutel per co-ouderschapsdossier.',
            serviceBoutTitre: 'Geen end-to-end-versleuteling',
            serviceBoutTexte: ', en dat zeggen we duidelijk: de dienst moet de geschiedenis kunnen voorzien van een tijdstempel, verzegelen en exporteren om zijn belofte na te komen. Uw inhoud kan door de dienst worden ontsleuteld, nooit door een derde partij.',
            serviceHistoriqueTitre: 'Gedeelde geschiedenis bewaard',
            serviceHistoriqueTexte: ': het verwijderen van een account anonimiseert de houder ervan, maar vernietigt niet de gedeelde geschiedenis, die ook aan de andere ouder toebehoort. Dit is een essentieel kenmerk van de dienst, aangegeven vanaf de registratie.',
            serviceSignatureTitre: 'Onafhankelijk bewijs',
            serviceSignatureTexte: ': elke vermelding wordt op het moment van registratie digitaal ondertekend door een onafhankelijke partij buiten Repère — dezelfde werkwijze als bij het waarmerken van een officieel document. Het bewijs dat er sindsdien niets is gewijzigd, blijft op elk moment controleerbaar.',
            servicePubTitre: 'Geen advertenties, geen tracker, geen doorverkoop.',
            servicePubTexte: ' Technische logboeken bevatten geen persoonsgegevens.',
            droitsTitre: 'Uw rechten',
            droitsTexte: 'Toegang, rectificatie, overdraagbaarheid, wissing, beperking en bezwaar worden uitgeoefend bij de dienst. De export van het dossier dient ook als antwoord op het inzagerecht. De contactgegevens van de functionaris voor gegevensbescherming worden hier gepubliceerd vóór de opening van de dienst.',
        },
        mentionsLegales: {
            titre: 'Wettelijke vermeldingen',
            description: 'Wettelijke vermeldingen van de site Repère.',
            avisProvisoire: 'Voorlopig document, in afwachting van juridische validatie. De identificatiegegevens van de uitgever en de host worden aangevuld vóór de opening van de dienst.',
            miseAJour: (date) => `Laatste update: ${date}.`,
            editeurTitre: 'Uitgever',
            editeurTexte: 'Repère — rechtsvorm, maatschappelijke zetel, registratienummer en publicatiedirecteur aan te vullen.',
            hebergementTitre: 'Hosting',
            hebergementTexte: 'De site en de dienst worden in Frankrijk gehost. Er worden geen gegevens overgedragen buiten de Europese Unie.',
            contactTitre: 'Contact',
            contactTexte: 'Contactadres aan te vullen.',
            proprieteTitre: 'Intellectuele eigendom',
            proprieteTexte: 'Het merk Repère, zijn logo en de inhoud van deze site zijn beschermd. Elke reproductie zonder toestemming is verboden.',
        },
    },
    notifications: {
        libelles: {
            message_new: { un: 'een nieuw bericht', plusieurs: (n) => `${n} nieuwe berichten` },
            proposal_new: {
                un: 'een nieuw akkoordverzoek',
                plusieurs: (n) => `${n} nieuwe akkoordverzoeken`,
            },
            proposal_answered: {
                un: 'een antwoord op een akkoordverzoek',
                plusieurs: (n) => `${n} antwoorden op akkoordverzoeken`,
            },
            expense_new: { un: 'een nieuwe uitgave', plusieurs: (n) => `${n} nieuwe uitgaven` },
            document_new: { un: 'een nieuw document', plusieurs: (n) => `${n} nieuwe documenten` },
            calendar_event_new: {
                un: 'een nieuw agenda-item',
                plusieurs: (n) => `${n} nieuwe agenda-items`,
            },
            alert_new: { un: 'een melding', plusieurs: (n) => `${n} meldingen` },
            professional_invited: {
                un: 'een geopende professionele toegang',
                plusieurs: (n) => `${n} geopende professionele toegangen`,
            },
            writing_opened: {
                un: 'schrijftoegang geopend op een dossier',
                plusieurs: (n) => `schrijftoegang geopend op ${n} dossiers`,
            },
        },
        enumeration: (morceaux) => morceaux.length <= 1
            ? (morceaux[0] ?? '')
            : `${morceaux.slice(0, -1).join(', ')} en ${morceaux.at(-1)}`,
    },
    mail: {
        verification: {
            objet: 'Bevestig uw e-mailadres',
            texte: (lien) => [
                'Hallo,',
                '',
                'Om uw e-mailadres bij Repère te bevestigen, opent u deze link:',
                lien,
                '',
                'Deze link is 24 uur geldig. Als u dit niet zelf heeft aangevraagd,',
                'kunt u dit bericht negeren: er wordt geen account geactiveerd.',
                '',
                'Repère — organisatie & gemoedsrust',
            ].join('\n'),
            titre: 'Bevestig uw e-mailadres',
            paragraphes: [
                'Hallo,',
                'Om uw e-mailadres bij Repère te bevestigen, gebruikt u de knop hieronder.',
            ],
            bouton: 'Mijn adres bevestigen',
            note: 'Deze link is 24 uur geldig. Als u dit niet zelf heeft aangevraagd, kunt u dit bericht negeren: er wordt geen account geactiveerd.',
        },
        invitationDossier: {
            objet: 'U bent uitgenodigd om deel te nemen aan een dossier op Repère',
            texte: (inviterName, lien) => [
                'Hallo,',
                '',
                `${inviterName} gebruikt Repère om het dagelijks leven van uw kinderen te organiseren`,
                'en stelt u voor om deel te nemen aan het dossier.',
                '',
                'Repère beschermt beide ouders op dezelfde manier: u krijgt precies',
                'dezelfde rechten, en de geschiedenis behoort aan geen van beiden toe. Niemand kan',
                'er iets uit verwijderen, of u uitsluiten.',
                '',
                'Om deel te nemen aan het dossier:',
                lien,
                '',
                'Deze link is 30 dagen geldig. Als u hem liever niet gebruikt, kunt u',
                'dit bericht negeren: er gebeurt niets.',
                '',
                'Repère — organisatie & gemoedsrust',
            ].join('\n'),
            titre: 'U bent uitgenodigd om deel te nemen aan een dossier',
            paragraphes: (inviterName) => [
                'Hallo,',
                `${inviterName} gebruikt Repère om het dagelijks leven van uw kinderen te organiseren en stelt u voor om deel te nemen aan het dossier.`,
                'Repère beschermt beide ouders op dezelfde manier: u krijgt precies dezelfde rechten, en de geschiedenis behoort aan geen van beiden toe. Niemand kan er iets uit verwijderen, of u uitsluiten.',
            ],
            bouton: 'Deelnemen aan het dossier',
            note: 'Deze link is 30 dagen geldig. Als u hem liever niet gebruikt, kunt u dit bericht negeren: er gebeurt niets.',
        },
        digest: {
            objet: 'Nieuws in uw Repère-dossier',
            texte: (resume, webUrl) => [
                'Hallo,',
                '',
                `Uw Repère-dossier bevat ${resume}.`,
                '',
                'Om het te bekijken:',
                webUrl,
                '',
                'U kunt uw stille uren en de frequentie van deze berichten',
                'aanpassen in uw accountvoorkeuren.',
                '',
                'Repère — organisatie & gemoedsrust',
            ].join('\n'),
            titre: 'Nieuws in uw dossier',
            paragraphes: (resume) => ['Hallo,', `Uw Repère-dossier bevat ${resume}.`],
            bouton: 'Mijn dossier openen',
            note: 'U kunt uw stille uren en de frequentie van deze berichten aanpassen in uw accountvoorkeuren.',
        },
        alerte: {
            objetUrgent: 'Dringende melding over uw Repère-dossier',
            objetNormal: 'Melding over uw Repère-dossier',
            texte: (motif, webUrl) => [
                'Hallo,',
                '',
                `Er is een melding geplaatst in uw Repère-dossier, met als reden "${motif}".`,
                '',
                'Om ze te lezen:',
                webUrl,
                '',
                'Repère — organisatie & gemoedsrust',
            ].join('\n'),
            titreUrgent: 'Dringende melding over uw dossier',
            titreNormal: 'Melding over uw dossier',
            paragraphes: ['Hallo,', 'Er is een melding geplaatst in uw Repère-dossier.'],
            encart: (motif) => `Opgegeven reden: "${motif}"`,
            bouton: 'Melding lezen',
        },
        invitationPro: {
            objet: 'Er is voor u een professionele toegang geopend op Repère',
            texte: (modules, url) => [
                'Hallo,',
                '',
                'Een ouder heeft voor u leestoegang geopend tot zijn of haar Repère-dossier.',
                '',
                `U zult zien: ${modules}.`,
                '',
                'Deze toegang is alleen-lezen: u schrijft niets, en niets van wat u',
                'bekijkt wordt gewijzigd door uw bezoek. Uw raadplegingen worden',
                'geregistreerd in het register van het dossier, dat beide ouders kunnen lezen.',
                'Elk van beide ouders kan er op elk moment een einde aan maken.',
                '',
                'Het is gratis en vrijblijvend. Om het terug te vinden:',
                url,
                '',
                'Repère — organisatie & gemoedsrust',
            ].join('\n'),
            titre: 'Er is voor u een professionele toegang geopend',
            paragraphes: (modules) => [
                'Hallo,',
                'Een ouder heeft voor u leestoegang geopend tot zijn of haar Repère-dossier.',
                `U zult zien: ${modules}.`,
                'Deze toegang is alleen-lezen: u schrijft niets, en niets van wat u bekijkt wordt gewijzigd door uw bezoek. Uw raadplegingen worden geregistreerd in het register van het dossier, dat beide ouders kunnen lezen. Elk van beide ouders kan er op elk moment een einde aan maken.',
                'Het is gratis en vrijblijvend.',
            ],
            bouton: 'Mijn toegang openen',
        },
        lienPaiement: {
            objet: 'Uw link om u op Repère te abonneren',
            texte: (lien) => [
                'Goedendag,',
                '',
                'U hebt zojuist vanuit de Repère-app om een abonnement gevraagd.',
                'Open deze link om af te ronden, op dit of op een ander apparaat:',
                lien,
                '',
                'Deze link is 1 uur geldig. Vraag daarna een nieuwe aan vanuit de app.',
                'Er wordt niets afgeschreven zolang u niet hebt bevestigd.',
                '',
                '— Repère',
            ].join('\n'),
            titre: 'Uw abonnement afronden',
            paragraphes: [
                'U hebt zojuist vanuit de app om een abonnement gevraagd. De betaling wordt hier afgerond, op dit of op een ander apparaat.',
                'Er wordt niets afgeschreven zolang u niet hebt bevestigd.',
            ],
            bouton: 'Betaling afronden',
            note: 'Deze link is 1 uur geldig. Vraag daarna een nieuwe aan vanuit de app.',
        },
        reinitialisation: {
            objet: 'Opnieuw instellen van uw wachtwoord',
            texte: (lien) => [
                'Hallo,',
                '',
                'U heeft gevraagd om uw Repère-wachtwoord opnieuw in te stellen. Open deze link:',
                lien,
                '',
                'Deze link is 1 uur geldig en werkt maar één keer.',
                'Als u dit niet zelf heeft aangevraagd, negeert u dit bericht:',
                'uw huidige wachtwoord blijft geldig.',
                '',
                'Repère — organisatie & gemoedsrust',
            ].join('\n'),
            titre: 'Opnieuw instellen van uw wachtwoord',
            paragraphes: ['Hallo,', 'U heeft gevraagd om uw Repère-wachtwoord opnieuw in te stellen.'],
            bouton: 'Mijn wachtwoord opnieuw instellen',
            note: 'Deze link is 1 uur geldig en werkt maar één keer. Als u dit niet zelf heeft aangevraagd, negeert u dit bericht: uw huidige wachtwoord blijft geldig.',
        },
        suppressionDossier: {
            objet: 'Een dossierverwijdering wacht op uw bevestiging',
            texte: (demandeur, lien) => [
                'Hallo,',
                '',
                demandeur
                    ? `${demandeur} heeft verwijdering aangevraagd van een Repère-dossier dat u deelt.`
                    : 'U hebt verwijdering aangevraagd van een van uw Repère-dossiers.',
                '',
                'Er is nog niets verwijderd. De verwijdering bevestigt u via deze link:',
                lien,
                '',
                'Na bevestiging blijft het dossier dertig dagen leesbaar zonder gewijzigd te',
                'kunnen worden, daarna wordt het definitief vernietigd. In die periode kan de',
                'verwijdering op elk moment worden geannuleerd, door ieder van beiden.',
                '',
                'Deze link is 7 dagen geldig. Zonder antwoord vervalt de aanvraag vanzelf en',
                'blijft het dossier ongeschonden.',
                '',
                'Repère — organisatie en rust',
            ].join('\n'),
            titre: 'Een dossierverwijdering wacht op uw bevestiging',
            paragraphes: (demandeur) => [
                'Hallo,',
                demandeur
                    ? `${demandeur} heeft verwijdering aangevraagd van een Repère-dossier dat u deelt.`
                    : 'U hebt verwijdering aangevraagd van een van uw Repère-dossiers.',
                'Er is nog niets verwijderd. Na bevestiging blijft het dossier dertig dagen leesbaar zonder gewijzigd te kunnen worden, daarna wordt het definitief vernietigd. In die periode kan de verwijdering op elk moment worden geannuleerd, door ieder van beiden.',
            ],
            bouton: 'Aanvraag openen',
            note: 'Deze link is 7 dagen geldig. Zonder antwoord vervalt de aanvraag vanzelf en blijft het dossier ongeschonden.',
        },
    },
    mobile: {
        notifications: {
            verification: 'Meldingen: controleren…',
            pretes: 'Meldingen klaar op dit apparaat.',
            refusees: 'U heeft meldingen geweigerd. U kunt ze weer inschakelen in de instellingen van uw telefoon.',
            indisponiblesTitre: 'Meldingen niet beschikbaar',
            appareilRattacheTitre: 'Apparaat geregistreerd',
            appareilActif: 'Dit apparaat is geregistreerd. U wordt gewaarschuwd, ook als de app gesloten is.',
            appareilInactif: 'U bent ingelogd, maar dit apparaat kan nog niet gewaarschuwd worden.',
        },
        dossiers: {
            titre: 'Uw dossiers',
            chargement: 'Laden…',
            erreur: 'Uw dossiers konden niet worden geladen.',
            aucun: 'Nog geen dossier. U kunt er een aanmaken in de webapp.',
            deconnexion: 'Uitloggen',
            ouvrirIndice: 'Opent de kalender van dit dossier',
        },
        calendrier: {
            retour: 'Terug',
            aujourdHui: 'Vandaag',
            jusqua: (heure) => `Tot ${heure}`,
        },
    },
};
//# sourceMappingURL=nl.js.map